import {
  useStoreId,
  useUID,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { useCallback } from "react";
import { TaskType } from "@coworker/apprestructured/src/task-management/types/TaskType";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";

const EMPTY_INITIAL_TASK = {};

function useCreateInitialTask() {
  const myUserId = useUID();
  const myStoreId = useStoreId();

  return useCallback(
    (taskType: TaskType | Loading) => {
      if (isLoading(taskType)) {
        return EMPTY_INITIAL_TASK;
      }

      const details = taskType.details.reduce(
        (res, curr) => {
          res[curr.name] = curr.initial;
          return res;
        },
        {} as Record<string, unknown>
      );

      return {
        priority: false,
        assigned_user_id: null,
        assigned_team_id: null,
        state: "pending",
        close_reason_id: null,
        close_description: "",
        image_ids: [],
        file_ids: [],
        start: null,
        creator_user_id: myUserId,
        store_id: myStoreId,
        details,
        task_type_id: taskType.id,
      };
    },
    [myStoreId, myUserId]
  );
}

export default useCreateInitialTask;
